// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: "Show me the mail" on a brief opens the mail itself. When a brief
// knows what it is about (its ref), an action that only asks to see it skips
// the assistant and opens the Home peek right there; anything else (draft a
// reply, schedule) still goes to the assistant as a prompt.

import {isRailWindow} from '@app/features/konvo_rail/utils/RailWindow';
import type {AssistantBriefRef} from '@fluxer/schema/src/domains/konvo/AssistantResponse';

const VIEW_WORDS = /^(show|open|view|see|read|look at|pull up)\b/i;

/** Whether tapping this action only means "let me see it". */
export function isViewAction(action: {label: string; prompt: string; icon?: string}): boolean {
	if (action.icon === 'view') return true;
	return VIEW_WORDS.test(action.label.trim()) || VIEW_WORDS.test(action.prompt.trim());
}

/**
 * Open what the brief is about in the peek; `fallback` runs when the peek cannot show it.
 * The peek is loaded on demand because it pulls in the mail, WhatsApp, task and channel stores.
 * The Rail's window is only as big as its panel, so there the main window opens it instead.
 */
export function openBriefRef(
	ref: AssistantBriefRef,
	title: string,
	anchor: HTMLElement | null,
	fallback: () => void,
): void {
	if (isRailWindow()) {
		void import('@app/features/konvo_rail/RailAssistantOpen')
			.then((module) => module.openBriefRefFromRail(ref))
			.catch(fallback);
		return;
	}
	void import('@app/features/konvo_today/components/HomePeekSources')
		.then((module) => {
			if (!module.openRefPeek(ref, title, anchor)) fallback();
		})
		.catch(fallback);
}
